import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function PortablePowerSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("portablePower.title")}</title>
        <meta name="keywords" content={t("portablePower.keywords")} />
        <meta name="description" content={t("portablePower.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a3348]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/portable-power-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_10%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f2438]/92 via-[#0f2438]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("portablePower.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("portablePower.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("portablePower.knowledgeBase.rootLabel")}
        rootColor="#059669"
        treeTranslationKey="portablePower.knowledgeBase.tree"
        i18nPrefix="portablePower.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="portablePower"
        images={{
          painPoints: "/solutions/portable-power-pain.jpeg",
          solutions: "/solutions/portable-power-solutions.jpeg",
          cta: "/solutions/portable-power-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 22%",
          solutions: "55% 24%",
          cta: "50% 5%",
        }}
      />
    </>
  );
}
